import './App.css';
import pikoland from "./images/raisin (1).png"

function App() {
  return (
    <div className="App">
     <div className="App">
     <h1>Coming Soon...</h1>
     <img src={pikoland} alt="" />
    </div>
    </div>
  );
}

export default App;
